import { Controller } from "@hotwired/stimulus"

// A single searchable field for picking a channel, unlike the plain
// channel-select <select> used in the routing matrix: <input list> hands
// filter-as-you-type to the browser's native datalist, so there's no separate
// search box bolted onto a disconnected dropdown.
export default class extends Controller {
  static targets = [ "input", "datalist", "value", "label" ]
  static values = { channelsUrl: String, selectedLabel: String }

  #channels = []

  connect() {
    if (this.selectedLabelValue) this.inputTarget.value = `#${this.selectedLabelValue.replace(/^#/, "")}`
    this.#loadChannels()
  }

  async refresh(event) {
    const button = event.currentTarget
    button.disabled = true
    try {
      const ok = await this.#loadChannels(true)
      window.toast(ok ? "Channel list refreshed" : "Couldn't refresh channel list", { kind: ok ? "success" : "error" })
    } finally {
      button.disabled = false
    }
  }

  // Fires on every keystroke and on picking a datalist option. Only a typed
  // value that exactly matches a channel resolves to an id and submits —
  // partial input just keeps the native datalist filtering.
  pick() {
    const match = this.#channels.find((c) => `#${c.name}` === this.inputTarget.value)
    if (!match) return

    this.valueTarget.value = match.id
    if (this.hasLabelTarget) this.labelTarget.value = `#${match.name}`
    this.element.closest("form").requestSubmit()
  }

  async #loadChannels(force = false) {
    try {
      const url = force ? `${this.channelsUrlValue}?refresh=1` : this.channelsUrlValue
      const response = await fetch(url, { headers: { "Accept": "application/json" } })
      if (!response.ok) return false

      this.#channels = await response.json()
      this.#renderDatalist()
      return true
    } catch {
      return false
    }
  }

  #renderDatalist() {
    this.datalistTarget.innerHTML = ""
    this.#channels.forEach(({ id, name }) => {
      const opt = document.createElement("option")
      opt.value = `#${name}`
      this.datalistTarget.appendChild(opt)
    })
  }
}
